import { Button, Dialog, textVariants, Text, breakpoints } from '@etg/wings';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { modalActionTypes, SEAT_MAP_PERSIST_DIALOG_ID } from '../constants/modal';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const buttonsWrapperStyles = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 5px;

  @media (min-width: ${breakpoints._970}) {
    flex-direction: row;
  }
`;
const buttonStyles = css`
  flex: 1;
`;
const SeatMapPersistDialog = ({
  isOpen,
  onSelection,
  segmentIndex
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsxs(Dialog, {
    closeButtonAriaLabel: t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
    "data-testid": SEAT_MAP_PERSIST_DIALOG_ID,
    id: SEAT_MAP_PERSIST_DIALOG_ID,
    isOpen: isOpen,
    title: t('Product.SeatMap.Persist.Modal.Title'),
    children: [/*#__PURE__*/_jsx(Text, {
      asHtml: true,
      variant: textVariants._14,
      children: t('Product.SeatMap.Persist.Modal.Text')
    }), /*#__PURE__*/_jsxs("div", {
      className: buttonsWrapperStyles,
      children: [/*#__PURE__*/_jsx(Button, {
        className: buttonStyles,
        "data-testid": "seatMap-persist-modal-dismiss",
        onClick: () => onSelection(modalActionTypes.SEAT_MAP_PERSIST_ACTION_DISMISS, null),
        children: t('Product.SeatMap.Persist.Modal.Actions.Accept')
      }), /*#__PURE__*/_jsx(Button, {
        className: buttonStyles,
        "data-testid": "seatMap-persist-modal-accept",
        onClick: () => onSelection(modalActionTypes.SEAT_MAP_PERSIST_ACTION_ACCEPT, segmentIndex),
        variant: "primary",
        children: t('Product.SeatMap.Persist.Modal.Actions.Dismiss')
      })]
    })]
  });
};
export default SeatMapPersistDialog;
//# sourceMappingURL=SeatMapPersistDialog.js.map